import React from "react";

import { ArrowRight } from "lucide-react";

const Subscribe = ({ data }) => {
  // Example: Color "Inspire" and "Vision"
  const highlightWords = [
    "Properties",
    "Manage",
    "Renting"
  ];
  const words = data.title.split(" ");

  return (
    <div className="w-[90%] mx-auto bg-[#F0F2F4] py-12 rounded-[28px] my-16 relative">
      <div className="flex flex-col items-center">
        <h5 className="font-popinsSemiBold text-themeColor text-3xl md:text-4xl lg:text-6xl xl:w-[60%] mx-auto text-center lg:tracking-[-5px]">
          {words.map((word, index) => {
            const cleanWord = word.replace(/[^\w]/g, ""); // remove punctuation
            const isHighlight = highlightWords.includes(cleanWord);
            return (
              <span key={index} className={isHighlight ? "text-btnColor" : ""}>
                {word}{" "}
              </span>
            );
          })}
        </h5>

        <button className="w-[90%] lg:w-[30%] group relative inline-flex mt-8 items-center justify-between rounded-full bg-[#1D1D1F] pl-10 pr-[6px] py-1 text-sm font-medium lg:gap-8 transition-all duration-300 hover:bg-white hover:text-black hover:border hover:border-[#1D1D1F] shadow text-white hover:shadow-md">
          <span className="font-popinsMedium">{data.btnText}</span>
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white group-hover:bg-[#1D1D1F] transition-all duration-300 group-hover:translate-x-1 group-hover:shadow">
            <ArrowRight className="w-4 h-4 text-black group-hover:text-white" />
          </span>
        </button>
      </div>
      <div className="absolute bottom-2 left-0 w-52 h-40 xl:w-72 xl:h-40 hidden lg:block">
        <img
          src="/assets/features/info.png"
          alt=""
          className="object-fill size-full"
        />
      </div>
    </div>
  );
};

export default Subscribe;
